//API进行统一管理
import requests from "@/api/request";

//axios请求后返回的是Promise
// /api/product/getBaseCategoryList get 无参数
export const reqNavbarList = () => requests({url: '/cms/column/list', method: 'get'})

export const reqArticleList = (contentType, params) => requests({
    url: `/cms/content/list?contentType=${contentType}`,
    method: 'post',
    data: params,
    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
})

export const searchArticleList = (keyword, params) => requests({
    url: `/cms/content/list?keyword=${keyword}`,
    method: 'post',
    data: params,
    headers: {'Content-Type': 'application/x-www-form-urlencoded'}
})

export const reqArticle = (id) => requests({url: `/cms/content/one/${id}`, method: 'get'})

export const reqCarouselList = (count=5) => requests({url: `/cms/content/banner/list/${count}`, method: 'post'})

export const reqOuterLink = (linkLocal) => requests({url: `/cms/link/list?linkLocal=${linkLocal}`, method: 'get'})

export const reqOtherConfig = () => requests({url: `/cms/other/config/detail/1`, method: 'get'})

/* 无线电宣传专栏相关 */
//获取轮播图列表
export const reqRadioCarouselList = (count = 5) => requests({url: `/cms/radiocontent/swiper/list/${count}`, method: 'post'})
//获取文章类型列表
export const reqRadioArticleTypeList = () => requests({url: `/cms/radiocontent/types`, method: 'get'})
//获取首页banner文章列表
export const reqRadioBannerContentList = (count = 6, radioType = 1) => requests({url: `/cms/radiocontent/banner/list/${count}?radioType=${radioType}`, method: 'POST'})
//根据条件分页获取文章列表
//headers: {'Content-Type': 'application/x-www-form-urlencoded'}
export const reqRadioArticleList = (params = {}) => requests({url: `/cms/radiocontent/list`, method: 'post', data: params, headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
//根据id获取文章详情
export const reqRadioArticleDetail = (id) => requests({url: `/cms/radiocontent/one/${id}`, method: 'get'})